// ##############################
// // // LoginPage view styles
// #############################

import {container} from "assets/jss/material-dashboard-pro-react.jsx";
import buttonStyle from "assets/jss/material-dashboard-pro-react/components/buttonStyle.jsx";
import customSelectStyle from "assets/jss/material-dashboard-pro-react/customSelectStyle.jsx";

const loginPageStyle = theme => ({
  container: {
    ...container,
    zIndex: 1,
    paddingRight: "0",
    paddingLeft: "0",
    maxWidth: "450px",
    [theme.breakpoints.down("sm")]: {
      paddingBottom: "100px"
    },
  },
  textCenter: {
    textAlign: "center"
  },
  justifyContentCenter: {
    justifyContent: "center !important"
  },
  customButtonClass: {
    "&,&:focus,&:hover": {
      color: "#FFFFFF"
    },
    marginLeft: "5px",
    marginRight: "5px"
  },
  inputAdornment: {
    marginRight: "18px"
  },
  inputAdornmentIcon: {
    color: "#555"
  },
  cardHidden: {
    opacity: "0",
    transform: "translate3d(0, -60px, 0)"
  },
  cardHeader: {
    marginBottom: "20px"
  },
  socialLine: {
    padding: "0.9375rem 0"
  },
  displayBlock: {
    "display": "block!important"
  },
  ...buttonStyle,
  ...customSelectStyle,
  selectFormControl: {
    ...customSelectStyle.selectFormControl,
    margin: "10px 1px 10px 0px !important"
  },
  registerForm: {
    padding: "10px 0px"
  },
  modalCardTitle: {
    fontSize: "23px",
    position: "relative",
    top: "5px",
    left: "10px",
    color: "#414141"
  },
  modalText: {
    display: "inline-block",
    textAlign: "justify"
  },
  forgotPassword: {
    color: "#ffffff",
    textAlign: "center",
    marginTop: "-10px",
    display: "block",
    "&:hover": {
      color: "#ffffff",
      textDecoration: "underline"
    },
    "&:focus": {
      color: "#eeeeee"
    }
  }
});

export default loginPageStyle;
